import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/useAuth';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isInitializing } = useAuth();

  if (isInitializing) {
    return (
      <div className="container py-5 app-session-loading" aria-busy="true" aria-live="polite">
        <div className="d-flex align-items-center gap-2 text-muted app-session-loading__content">
          <div className="spinner-border spinner-border-sm" role="status" aria-label="Loading"></div>
          <span>Checking session…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return children;
};

export default RequireAuth;
